/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const brands = {
    1029: 'Shari\'s Berries',
    1010: 'Fruit Bouquets',
    1020: 'Wolferman\'s',
    1001: '1-800-Flowers',
    1019: 'Harry & David',
    1009: '1-800-Baskets',
    1025: 'Simply Chocolate',
    1012: 'Cheryl\'s Cookies',
    1022: 'Personalization Universe',
    1002: 'The Popcorn Factory',
    1018: 'Stock Yards',
    1030: 'Personalization Mall',
    1031: 'Vital Choice',
    1027: 'The Market',
    1033: 'Things Remembered',
    1034: 'Florists',
    1036: 'Cardisle',
    1038: 'Celebrations',
};

export const brandCode = {
    1029: 'bry',
    1010: 'fbq',
    1020: 'wlf',
    1001: '18f',
    1019: 'hd',
    1009: '18b',
    1025: 'sch',
    1012: 'cco',
    1022: 'pzu',
    1002: 'tpf',
    1018: 'sy',
    1030: 'pma',
    1031: 'vc',
    1027: 'tmp',
    1033: 'tr',
    1034: 'fl',
    1036: 'ci',
    1038: 'csg',
};

export const getSisterBrandName = (productBrand, currentBrand) => {
    if (!productBrand || !currentBrand) {
        return null;
    }
    if (productBrand !== currentBrand && brands[productBrand]) {
        return brands[productBrand];
    }
    return null;
};

export const getSisterBrandCode = (productBrand) => {
    if (productBrand) {
        return brandCode[productBrand];
    }
    return null;
};

export const getSkuWithoutBrand = (skuId = '') => {
    const splitSku = skuId?.split?.('-');
    return splitSku?.[splitSku?.length - 1] || '';
};

export const cartStatusCompleteList = ['published', 'placed', 'paid', 'publishfailed', 'testcart'];

export default {};
